export default {
  transaction: {
    title: 'लेन-देन',
    select: 'चुनें',
    all: 'सभी',
    loading: 'लोड हो रहा है...',
    noMoreData: 'और डेटा नहीं',
    mockSuccess: 'नकली सफलता',
    mockFail: 'नकली विफलता',
    mockSuccessDone: 'नकली सफलता पूर्ण',
    mockFailDone: 'नकली विफलता पूर्ण',
    mockFailed: 'नकली प्रयास विफल',
    today: 'आज',
    yesterday: 'कल',
    last3Days: 'पिछले 3 दिन',
    last7Days: 'पिछले 7 दिन',
    last15Days: 'पिछले 15 दिन',
    last30Days: 'पिछले 30 दिन',
    allTypes: 'सभी प्रकार',
    deposit: 'जमा',
    withdrawal: 'निकासी',
    withdrawalRefund: 'निकासी वापसी',
    bet: 'दांव',
    win: 'जीत',
    manualAdd: 'मैनुअल जोड़',
    manualSubtract: 'मैनुअल कटौती',
    commission: 'कमीशन',
    bonus: 'बोनस',
    vipUpgradeReward: 'VIP अपग्रेड पुरस्कार',
    vipSalary: 'VIP वेतन',
    gameOutPrincipal: 'गेम आउट - मूलधन',
    gameOutBonus: 'गेम आउट - बोनस',
    bonusTransferOut: 'बोनस स्थानांतरण',
    allStats: 'सभी स्थितियाँ',
    underReview: 'समीक्षाधीन',
    pendingPayout: 'भुगतान लंबित',
    successful: 'सफल',
    failed: 'विफल',
    cancelled: 'रद्द',
    processing: 'प्रसंस्करण',
  },
};
